import React from 'react'

import logo from './assets/logo.svg'
import styles from './Logo.scss';

const Logo = props => <a href="/"><img alt="Logo" src={logo} className={styles.logo}  {...props}/></a>

export default Logo



// WEBPACK FOOTER //
// ./src/components/atoms/Logo/index.js